import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { ShBaseFormComponent } from '../../_core/base-form/base-form.component';
import { ShFormTextareaBaseComponent } from '../base-simple/form-textarea-base.component';
import { ReactiveFormsModule } from '@angular/forms';
import { ShFormTextareaComplexBaseComponent } from '../base-complex/form-textarea-complex-base.component';
import { NgIf, NgClass, AsyncPipe } from '@angular/common';
import { ShFormGroupComponent } from '../../_core/form-group/form-group.component';

@Component({
    selector: 'sh-form-textarea-input',
    templateUrl: './form-textarea.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [ShFormGroupComponent, NgIf, ShFormTextareaComplexBaseComponent, ReactiveFormsModule, NgClass, ShFormTextareaBaseComponent, AsyncPipe]
})
export class ShFormTextareaInputComponent extends ShBaseFormComponent {
    @Input() autocomplete = 'off';
    @Input() placeholder?: string;
    @Input() resizable?: boolean;
    @Input() rows?: number = 5;
}
